module.exports = __webpack_public_path__ + "img/basketball-icon-white.1ed7ccfa.png";